import { useEffect, useRef, useState } from "react";
import UseFetch from "../components/UseFetch";
import { impression } from "../components/const";
import $ from 'jquery'
const Benefice = () => {
    const { data: benefice, isloading } = UseFetch('admin/benefice')
    const [beneficePeriode, setBeneficePeriode] = useState(benefice)

    const [datejour, setDateJour] = useState((new Date()).toISOString().slice(0, 10));
    const [date1, setDate1] = useState(datejour);
    const [date2, setDate2] = useState(datejour);
    const [total, setTotal] = useState(0)
    const [totalfacture, setTotalFacture] = useState(0)
    const [totaldepense, setTotalDepense] = useState(0)
    const [totalbenefice, setTotalBenefice] = useState(0)
    const printElement = useRef()
    const tableRef = useRef()
    useEffect(() => {
        if (beneficePeriode) {
            setTotal(beneficePeriode?.reduce((previous, current) => { return previous + current.montant_achat }, 0))
            setTotalFacture(beneficePeriode?.reduce((previous, current) => { return previous + current.montant }, 0))
            setTotalDepense(beneficePeriode?.reduce((previous, current) => { return previous + current.depense }, 0))
            setTotalBenefice(beneficePeriode?.reduce((previous, current) => { return previous + current.benefice }, 0))
        }
    }, [beneficePeriode])


    const handleShowByPeriode = () => {
        const start = date1 ? new Date(date1) : null;
        const end = date2 ? new Date(date2) : null;
        const result = benefice?.filter(item => {
            const itemDate = new Date(item.date);
            return (!start || itemDate >= start) && (!end || itemDate <= end);
        });
        setBeneficePeriode(result)
    }
    return (
        isloading ? <div className="loader"></div> : benefice?.length ? <div className="benefice">
            <div className="row mb-2  p-3 rounded justify-content-between bg-white">
                <div className="col-lg-6">
                    <div className="h6 text-primary">FANSAN TEXTIL-COMPTABILITY</div>
                </div>
                <div className="bg-white mt-2  w-100   p-2 text-secondary d-flex  align-items-center">

                    <h6 className="text-secondary">BENEFICE DU</h6>

                    <input type="date" className="form-control w-auto m-1" id="date1" name="date1" defaultValue={date1} onChange={(e) => setDate1(e.target.value)} />
                    AU
                    <input type="date" className="form-control w-auto m-1" id="date2" name="date2" defaultValue={date2} onChange={(e) => setDate2(e.target.value)} />

                    <button type="submit" className="btn btn-primary  m-1 align-self-end" onClick={() => handleShowByPeriode()}><i className="bx bx-search" ></i></button>

                    <button className="btn btn-primary" onClick={() => impression(printElement.current, 'landscape', "BENEFICES")}><i className="bx bx-printer"></i></button>
                </div>
            </div>
            <div className="table-responsive" ref={printElement}>
                <table ref={tableRef} className="table table-hover table-striped table-bordered">
                    <thead className="table-dark border-white text-center">
                        <tr className="align-middle text-center">
                            <th>N°</th>
                            <th>N°CONT</th>
                            <th>CONTENEUR</th>
                            <th>FOURNISSEUR</th>
                            <th>MONTANT ACHAT</th>
                            <th>MONTANT FACTURE</th>
                            <th>DEPENSE</th>
                            <th>BENEFICE VIRTUEL</th>
                            <th>BENEFICE REEL</th>
                            <th>DIFFERENCE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            beneficePeriode?.map((ben, ind) => (
                                <tr key={ind} className="align-middle ">
                                    <td>{ind + 1}</td>
                                    <td>{ben.numero}</td>
                                    <td>{ben.conteneur}</td>
                                    <td>{ben.fournisseur}</td>
                                    <td>{ben.montant_achat?.toLocaleString()}</td>
                                    <td>{ben.montant?.toLocaleString()}</td>
                                    <td>{ben.depense?.toLocaleString()}</td>
                                    <td>{ben.benefice?.toLocaleString()}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

                <div className="row justify-content-center align-items-center p-2">
                    <div className="col-lg-3 w-auto p-2">
                        <div className="card p-2">
                            Total Montant Achat
                            <span className="fw-bold"> {total?.toLocaleString()} GNF</span>
                        </div>
                    </div>
                    <div className="col-lg-3 w-auto p-2">
                        <div className="card p-2">
                            Total Factures
                            <span className="fw-bold"> {totalfacture?.toLocaleString()} GNF</span>
                        </div>
                    </div>
                    <div className="col-lg-3 w-auto p-2">
                        <div className="card p-2">
                            Total Depenses
                            <span className="fw-bold"> {totaldepense?.toLocaleString()} GNF</span>
                        </div>
                    </div>
                    <div className="col-lg-3 w-auto p-2">
                        <div className="card p-2">
                            Total Benefices
                            <span className="fw-bold"> {totalbenefice?.toLocaleString()} GNF</span>
                        </div>
                    </div>
                </div>

            </div>
        </div> : <div className="w-100 p-2 bg-danger-subtle text-danger fs-3 text-center"> Aucun benefice</div>
    );
}

export default Benefice;